<template>
  <div class="col-xl-4 col-lg-6 d-flex p-3">
    <div class="bg-white d-block rounded-12 p-4 mb-4 w-100 h-100">
      <div class="d-flex justify-content-between">
        <div class="col d-flex align-items-center">
          <img :src="data.collectionImage?.[0] || '/img/user-3.jpg'" class="treatment rounded-2">
          <div class="col ps-3">
            <div class="text-md text-medium">{{ data.name }}</div>
            <ul class="item-info mb-0">
              <li>
                <span class="text-sm text-medium">
                  {{ data.durationHours || 0 }} Jam {{ data.durationMinutes || 0 }} Menit
                </span>
              </li>
              <li>
                <span class="text-sm color-red-100 text-semiBold">
                  Rp {{ data.price.toLocaleString('id-ID') }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr class="dashed">

      <div v-if="ingredients.length > 0">
        <div class="text-sm text-medium mb-2">Bahan yang Digunakan</div>
        <hr class="solid">
        <div class="d-flex flex-column mb-3">
          <div v-for="ingredient in limitedIngredients" :key="ingredient.id" class="d-flex flex-column py-1">
            <div class="text-sm color-gray-80">{{ ingredient.name || '-' }}</div>
            <div class="text-xs text-medium">
              Sisa Stok: 
              <span :class="getStockClass(ingredient.stock)">
                 {{ getStockIndicator(ingredient.stock) }}
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <div v-if="ingredients.length > 3" class="text-sm color-gray-80">
              +{{ ingredients.length - 3 }} lainnya
            </div>
            <a v-if="ingredients.length > 0" @click="setTreatmentDetail" class="text-sm detail-treatment text-medium">
              Lihat Detail
            </a>
          </div>
        </div>
      </div>
      <pre v-if="debug">{{ ingredients }}</pre>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["data"],
  data() {
    return {
      ingredients: [],
      debug: false,
    };
  },
  computed: {
    limitedIngredients() {
      return this.ingredients.slice(0, 3);
    }
  },
  methods: {
    setTreatmentDetail() {
      this.$emit("showDetail", this.data);
    },
    async fetchIngredients() {
      if (!this.data.accu_treatment_id) {
        console.warn("⚠️ accu_treatment_id tidak tersedia, melewati pengambilan bahan baku.");
        return;
      }
      try {
        const response = await axios.get('/kfs-inventory/ingredients/by-treatment', {
          params: { 'where[accuTreatmentId]': Number(this.data.accu_treatment_id) }
        });

        this.ingredients = response.data.data ? [...response.data.data] : [];
        
        this.$nextTick(() => {
        });
      } catch (error) {
        console.error("❌ Error fetching materials:", error);
      }
    },
    getStockIndicator(stock) {
      if (stock > 10) return "✅";
      if (stock > 0) return "⚠️";
      return "❌";
    },
    getStockClass(stock) {
      if (stock > 10) return "color-green";
      if (stock > 0) return "color-orange";
      return "color-red";
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newData) {
        console.log("🔄 Data berubah:", newData);
        if (newData.accu_treatment_id) {
          this.fetchIngredients();
        }
      }
    }
  }
};
</script>

<style scoped>
.color-green {
  color: green;
}
.color-orange {
  color: orange;
}
.color-red {
  color: red;
}
</style>
